<template>
  <main-large-dialog
    :is-visible.sync="computedIsVisible"
    :title="additionalModuleName"
    disagree-text="dialog.disagreeClose"
    :has-agree="false"
    no-paddings-y
    no-paddings-x
    @modalClosed="onClose"
    dialog-width="76%"
    max-height="90vh"
    bodyHeight="70vh"
    header-shadow
    :loading="isLoading"
  >
    <template #body>
      <v-col cols="12" class="fill-height" style="overflow-y: auto;">
        <v-row no-gutters class="tableHeader tableRow">
          <v-col :cols="item.cols" v-for="(item, index) in tableHeaders" :key="index">
            <div class="font-weight-bold pt-4">
              {{ item.text }}
            </div>
            <div class="text-caption font-italic font-weight-light pa-0">
              {{ item.optional }}
            </div>
          </v-col>
        </v-row>
        <v-form
          v-model="isNewPointValid"
          ref="addForm"
          style="position: sticky; top: 100px; z-index: 3; background-color: white;"
        >
          <v-row no-gutters class="tableRowAdd tableRow">
            <v-col cols="2" class="pl-4">
              <data-input
                :data-type="dataTypeInteger"
                v-model="scadaPoint.junction_id"
                :rules="[v => !!v || v == '0' || 'rules.required']"
              ></data-input>
            </v-col>
            <v-col cols="2">
              <data-input
                :data-type="dataTypeSelect"
                v-model="scadaPoint.system"
                @input="handleGetMeasurements(scadaPoint.system)"
                :items="scadaSystems"
                :rules="[v => !!v || v == '0' || 'rules.required']"
              ></data-input>
            </v-col>
            <v-col cols="2">
              <data-input
                :data-type="dataTypeAutocomplete"
                :items="computedNewMeasurementItems"
                :loading="isMeasurementsLoading"
                v-model="scadaPoint.external_name"
                :rules="[v => !!v || v == '0' || 'rules.required']"
                :disabled="!scadaPoint.system"
              ></data-input>
            </v-col>
            <v-col cols="2">
              <data-input
                :data-type="dataTypeAutocomplete"
                v-model="scadaPoint.recipient"
                :items="recipients"
                clearable
              ></data-input>
            </v-col>
            <v-col cols="1">
              <v-tooltip bottom color="font">
                <template #activator="{ on }">
                  <v-icon v-on="on" color="success" :disabled="!isNewPointValid" @click="handleAddJunction">
                    mdi-check
                  </v-icon>
                </template>
                {{ $i18n.t('dialog.save') }}
              </v-tooltip>
            </v-col>
          </v-row>
        </v-form>
        <v-form v-model="isEditPointValid">
          <v-row no-gutters class="tableRow" v-for="item in computedScadaJunctions" :key="item.index">
            <template v-if="item.isEdit">
              <v-col cols="2" class="pl-4">
                <data-input
                  :data-type="dataTypeInteger"
                  v-model="editItem.junction_id"
                  :rules="[v => !!v || v == '0' || 'rules.required']"
                ></data-input>
              </v-col>
              <v-col cols="2">
                <data-input
                  :data-type="dataTypeSelect"
                  v-model="editItem.system"
                  @input="handleGetMeasurements(editItem.system)"
                  :items="scadaSystems"
                  :rules="[v => !!v || v == '0' || 'rules.required']"
                ></data-input>
              </v-col>
              <v-col cols="2">
                <data-input
                  :data-type="dataTypeAutocomplete"
                  :items="computedEditMeasurementItems"
                  v-model="editItem.external_name"
                  :loading="isMeasurementsLoading"
                  :rules="[v => !!v || v == '0' || 'rules.required']"
                  :disabled="!editItem.system"
                ></data-input>
              </v-col>
              <v-col cols="2">
                <data-input
                  :data-type="dataTypeAutocomplete"
                  v-model="editItem.recipient"
                  :items="recipients"
                  clearable
                ></data-input>
              </v-col>
              <v-col cols="1">
                <v-tooltip bottom color="font">
                  <template #activator="{ on }">
                    <v-icon
                      v-on="on"
                      color="success"
                      class="mr-4"
                      @click="handleEditScadaJunction"
                      :disabled="!isEditPointValid"
                    >
                      mdi-check
                    </v-icon>
                  </template>
                  {{ $i18n.t('dialog.save') }}
                </v-tooltip>
                <v-tooltip bottom color="font">
                  <template #activator="{ on }">
                    <v-icon v-on="on" color="error" class="mr-2" @click="stopEditing(item)">mdi-close</v-icon>
                  </template>
                  {{ $i18n.t('dialog.disagree') }}
                </v-tooltip>
              </v-col>
            </template>
            <template v-else>
              <v-col cols="2" :class="column.class" v-for="(column, index) in item.columns" :key="index">
                {{ column.value }}
              </v-col>
              <v-col cols="1">
                <v-tooltip bottom color="font">
                  <template #activator="{ on }">
                    <v-icon v-on="on" color="text" class="mr-4" @click="startEditing(item)">mdi-pencil</v-icon>
                  </template>
                  {{ $i18n.t('dialog.edit') }}
                </v-tooltip>
                <v-tooltip bottom color="font">
                  <template #activator="{ on }">
                    <v-icon v-on="on" color="error" class="mr-2" @click="confirmJunctionDelete(item.id)"
                      >mdi-delete</v-icon
                    >
                  </template>
                  {{ $i18n.t('dialog.agreeDelete') }}
                </v-tooltip>
              </v-col>
            </template>
          </v-row>
        </v-form>

        <main-dialog
          v-if="isDeleteDialogLoaded"
          :is-visible.sync="isDeleteDialogVisible"
          :title="$i18n.t('dialog.title.deleteSCADAPoint')"
          :body="$i18n.t('dialog.body.deleteScadaJunctionConfirmation')"
          agree-text="dialog.agreeDelete"
          @agree="handleDeleteJunction"
          :loading="isDeleting"
        />
      </v-col>
    </template>
  </main-large-dialog>
</template>

<script>
import { call, get } from 'vuex-pathify';
import DataInput from '@/components/DataInput';
import MainLargeDialog from '@/components/MainLargeDialog';
export default {
  name: 'ScadaPointsDialog',
  components: {
    MainDialog: () => import('@/components/MainDialog'),
    DataInput,
    MainLargeDialog,
  },
  props: {
    isVisible: {
      type: Boolean,
      required: true,
    },
  },
  data: () => ({
    scadaPoint: {},
    isNewPointValid: false,
    isEditPointValid: false,
    isDeleteDialogVisible: false,
    isDeleteDialogLoaded: false,
    isMeasurementsLoading: false,
    isLoading: false,
    isDeleting: false,
    dataTypeInteger: { name: 'integer' },
    dataTypeSelect: { name: 'select' },
    dataTypeAutocomplete: { name: 'autocomplete' },
    editItem: undefined,
    junctionIdToDelete: undefined,
  }),
  computed: {
    additionalModuleName: get('admin/additionalModules@SCADA_JUNCTIONS.verbose_name'),
    recipients: get('epanet/recipients'),
    scadaJunctions: get('epanet/scadaJunctions'),
    scadaSystems: get('epanet/scadaSystems'),
    scadaMeasurements: get('epanet/scadaMeasurements'),
    computedNewMeasurementItems() {
      if (this.scadaPoint.system === 'TelWin') {
        return this.scadaMeasurements['TelWin'];
      } else if (this.scadaPoint.system === 'Historian') {
        return this.scadaMeasurements['Historian'];
      } else {
        return [];
      }
    },
    computedEditMeasurementItems() {
      if (this.editItem.system === 'TelWin') {
        return this.scadaMeasurements['TelWin'];
      } else if (this.editItem.system === 'Historian') {
        return this.scadaMeasurements['Historian'];
      } else {
        return [];
      }
    },
    computedScadaJunctions() {
      return this.scadaJunctions.map(item => {
        return {
          ...item,
          index: this.scadaJunctions.indexOf(item),
          isEdit: this.editItem?.index === this.scadaJunctions.indexOf(item),
          columns: [
            { dataType: this.dataTypeInteger, class: 'pl-4 pb-1', value: item.junction_id },
            { dataType: this.dataTypeSelect, value: item.system },
            { dataType: this.dataTypeAutocomplete, value: item.external_name },
            { dataType: this.dataTypeSelect, value: item.recipient },
          ],
        };
      });
    },
    computedIsVisible: {
      get() {
        return this.isVisible;
      },
      set(nV) {
        this.$emit('update:isVisible', nV);
      },
    },
    tableHeaders() {
      return [
        { text: this.$i18n.t('navbar.scadaModal.headers.junction_id'), cols: '2' },
        { text: this.$i18n.t('navbar.scadaModal.headers.system'), cols: '2' },
        { text: this.$i18n.t('navbar.scadaModal.headers.external_name'), cols: '2' },
        {
          text: this.$i18n.t('navbar.scadaModal.headers.recipient'),
          cols: '2',
          optional: this.$i18n.t('navbar.scadaModal.headers.optional'),
        },
        { text: '', cols: '1' },
      ];
    },
  },
  methods: {
    getRecipients: call('epanet/getRecipients'),
    getScadaJunctions: call('epanet/getScadaJunctions'),
    getScadaSystems: call('epanet/getScadaSystems'),
    addScadaJunction: call('epanet/addScadaJunction'),
    editScadaJunction: call('epanet/editScadaJunction'),
    deleteScadaJunction: call('epanet/deleteScadaJunction'),
    getScadaMeasurementsForSystem: call('epanet/getScadaMeasurementsForSystem'),
    async handleAddJunction() {
      const payload = { ...this.scadaPoint };
      await this.addScadaJunction(payload);
      this.scadaPoint = {};
      this.$refs.addForm.reset();
    },
    async handleEditScadaJunction() {
      const body = {
        external_name: this.editItem.external_name,
        junction_id: this.editItem.junction_id,
        recipient: this.editItem.recipient,
        system: this.editItem.system,
      };
      const payload = { id: this.editItem.id, body };
      await this.editScadaJunction(payload);
      this.editItem = {};
    },
    async handleGetMeasurements(value) {
      if (this.scadaMeasurements[value] === undefined && value !== null) {
        this.isMeasurementsLoading = true;
        try {
          await this.getScadaMeasurementsForSystem(value);
        } finally {
          this.isMeasurementsLoading = false;
        }
      }
    },
    async handleDeleteJunction() {
      this.isDeleting = true;
      try {
        await this.deleteScadaJunction(this.junctionIdToDelete);
      } finally {
        this.junctionIdToDelete = undefined;
        this.isDeleting = false;
        this.isDeleteDialogVisible = false;
      }
    },
    confirmJunctionDelete(id) {
      this.junctionIdToDelete = id;
      this.isDeleteDialogLoaded = true;
      this.isDeleteDialogVisible = true;
    },
    async startEditing(item) {
      await this.handleGetMeasurements(item.system);
      this.editItem = item;
    },
    stopEditing() {
      this.editItem = undefined;
    },
    onClose() {
      this.editItem = undefined;
      this.scadaPoint = {};
    },
    async init() {
      this.isLoading = true;
      await Promise.all([this.getScadaJunctions(), this.getRecipients(), this.getScadaSystems()]);
      this.editItem = undefined;
      this.isLoading = false;
    },
  },
  mounted() {
    this.init();
  },
};
</script>

<style scoped lang="scss">
.tableHeader {
  position: sticky;
  top: 0;
  background-color: white;
  height: 100px;
  z-index: 3;
}
.tableRow {
  @include border(bottom);
  padding: 9px 0;
  justify-content: space-evenly;
  align-items: center;
}
.tableRowAdd {
  @include border(bottom);
  position: sticky;
  top: 100px;
  background-color: white;
  align-items: baseline;
  z-index: 3;
}
</style>
